// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutsTableComponents-IconsContainer_cls1__zOv7T","cls2":"PayoutsTableComponents-IconsContainer_cls2__t-JlG PayoutsTableComponents-IconsContainer_cls1__zOv7T"};